import { BaseRouteService } from 'core/services';

class TrackingRouteService extends BaseRouteService {
	constructor() {
		super();
		this.base = 'track/';
	}

	track = () => {
		return this.uriTemplateService.parse(this.base + 'track-package').expand();
	};
}

export default TrackingRouteService;



// WEBPACK FOOTER //
// ./src/common/data/route-services/TrackingRouteService.js